var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwrokGradiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 146,
    viewBox: "0 0 227 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.724609,
    y: 0.949219,
    width: 225.819,
    height: 144.397,
    rx: 10.8174,
    fill: "url(#paint0_linear_795_2351)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_795_2351",
    x1: 0.724608,
    y1: 73.1477,
    x2: 226.544,
    y2: 73.1477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FA50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6423"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwrokGradiant);
export default __webpack_public_path__ + "static/media/netwrokGradiant.b42064a7007a9f09c67b6f9f72069160.svg";
export { ForwardRef as ReactComponent };